import { jsx as _jsx } from "react/jsx-runtime";
import { VideoPlayerTypes } from '@as-react/common-types';
import { YouTubeVideo } from './YouTubeVideo';
import { VimeoVideo } from './VimeoVideo';
import { NativeVideo } from './NativeVideo';
export const Video = props => {
    switch (props.playerType) {
        case VideoPlayerTypes.VIMEO:
            return _jsx(VimeoVideo, Object.assign({}, props));
        case VideoPlayerTypes.YOUTUBE:
            return _jsx(YouTubeVideo, Object.assign({}, props));
        case VideoPlayerTypes.NATIVE:
            return _jsx(NativeVideo, Object.assign({}, props));
        default:
            return null;
    }
};
